import React, { useEffect, useState } from 'react'
import { Box, Dialog, IconButton, Typography } from '@material-ui/core'
import { Close as CloseIcon } from '@material-ui/icons'
import ResultButton from 'src/views/FileUploadView/components/ResultButton'
import { FinishedBrowser } from './FinishedList'

// Finished analyses in a dialog, for "Add samples" to a group and "Add a group".

const BUTTON_SX = { height: 36, px: 2, fontSize: 14 }

/**
 * @param taken  Set of fileIds already in the target group
 * @param onAdd  (rows) => void
 */
const FinishedPickerDialog = ({ open, onClose, title = 'Add finished analyses', taken, onAdd, newGroup }) => {
  const [selected, setSelected] = useState(() => new Map())

  useEffect(() => {
    if (open) setSelected(new Map())
  }, [open])

  const toggle = (row) =>
    setSelected((prev) => {
      const next = new Map(prev)
      if (next.has(row.fileId)) next.delete(row.fileId)
      else next.set(row.fileId, row)
      return next
    })

  const selectMany = (rows) =>
    setSelected((prev) => {
      const next = new Map(prev)
      rows.forEach((row) => next.set(row.fileId, row))
      return next
    })

  const count = selected.size
  const noun = count === 1 ? 'sample' : 'samples'
  let label = count ? `Add ${count} ${noun}` : 'Add samples'
  if (newGroup) label = count ? `Add ${count} as a group` : 'Add as a group'

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      PaperProps={{ sx: { borderRadius: '12px', height: 'min(760px, calc(100% - 64px))', m: 2 } }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', px: 3, pt: 2.5, pb: 1 }}>
        <Typography sx={{ fontSize: 18, fontWeight: 600, flex: 1 }}>{title}</Typography>
        <IconButton onClick={onClose} aria-label="Close" size="small">
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>
      <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', px: 2, pt: 1 }}>
        {open && (
          <FinishedBrowser
            selected={selected}
            taken={taken}
            onToggle={toggle}
            onSelectMany={selectMany}
            autoFocus
            listSx={{ flex: 1, minHeight: 0, overflowY: 'auto', maxHeight: 'calc(min(760px, 100vh - 64px) - 220px)' }}
          />
        )}
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 1.5, px: 3, py: 2 }}>
        <ResultButton onClick={onClose} sx={BUTTON_SX}>
          Cancel
        </ResultButton>
        <ResultButton primary disabled={!count} onClick={() => onAdd(Array.from(selected.values()))} sx={BUTTON_SX}>
          {label}
        </ResultButton>
      </Box>
    </Dialog>
  )
}

export default FinishedPickerDialog
